module.exports = __webpack_public_path__ + "assets/img/zhongdian.01a40b4c.svg";